import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../components/Layout/Layout';
import SEO from '../../components/SEO/SEO';

function SignIn({}) {
  return (
    <Layout>
      <SEO title='SignIn' />
      <div className='placeholder-block'>
        <h1>Sign In Page</h1>
      </div>
      <div className='placeholder-block'>
        <h2 className='form'>Form - Sign In</h2>
        <a href='/portal/onboarding/'>Create Account</a>
        <a href='/portal/account-help/forgot-username'>Forgot Username</a>
        <a href='/portal/account-help/forgot-password'>Forgot Password</a>
      </div>
    </Layout>
  );
}

SignIn.getInitialProps = async ({}) => {
  try {
    // Fetch server-rendered data here
    return { data: {} };
  } catch (error) {
    // Handle issues loading data
    if (error.response.status === 404) return { statusCode: 404 };
    return { error };
  }
};

SignIn.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  data: PropTypes.shape({}),
  error: PropTypes.object,
};

export default SignIn;
